//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import { CATALOGS_DATE_LINE_FORMAT } from "@/assets/js/appConfig";
import { date } from "quasar";

const apiIcon = require("@/assets/images/new-api.svg");

export default {
    name: "Logs",
    components: {
        AQButton,
        AQDialog,
        AQDropdown,
        AQInput
    },
    data() {
        return {
            showDialog: false,
            selectedApp: null,
            fromDateTime: "",
            dateTimeFormat: "DD.MM.YYYY",
            toDateTime: "",
            appsOptions: [],
            searchAppValue: "",
            fromDateTimeErr: false,
            toDateTimeErr: false,
            today: "",
            searchAppPayload: {
                page: 0,
                search: "",
                ids: [],
                archived: true
            },
            optionsMenu: "",
            currentDialog: "",
            logList: [
                {
                    icon: apiIcon,
                    title: this.$t("admin.logs.titleApi"),
                    description: this.$t("admin.logs.descriptionApi"),
                    type: "api"
                },
                {
                    icon: apiIcon,
                    title: this.$t("admin.logs.titleSecurity"),
                    description: this.$t("admin.logs.descriptionSecurity"),
                    type: "security"
                },
                {
                    icon: apiIcon,
                    title: this.$t("admin.logs.titleAttachments"),
                    description: this.$t("admin.logs.descriptionAttachments"),
                    type: "attachments"
                }
            ]
        };
    },
    computed: {
        ...mapGetters("apps", ["hasMoreApps"]),
        getAllApplicationsProps() {
            return {
                placeholder: this.$t("admin.logs.allApplications"),
                options: this.appsOptions,
                addSearch: true,
                hasPagination: true,
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left",
                clearable: true
            };
        },
        dialogTitle() {
            let title = "";
            switch (this.currentDialog) {
                case "api": title = this.$t("admin.logs.dialogTitle"); break;
                case "security": title = this.$t("admin.logs.titleSecurity"); break;
                case "attachments": title = this.$t("admin.logs.titleAttachments"); break;
                default:
            }
            return title;
        },
        dialogMessage() {
            return this.$t("admin.logs.logsMessage");
        }
    },
    watch: {
        searchAppValue: {
            handler(value) {
                if (value) {
                    const searchV = value.trim();
                    if (searchV && searchV.length > 3) {
                        this.searchAppPayload.page = 0;
                        this.searchData(searchV);
                    }
                } else {
                    this.searchAppPayload.page = 0;
                    this.searchData();
                }
            },
            immediate: true
        }
    },
    activated() {
        this.searchAppPayload.page = 0;
        this.getApplications();
    },
    methods: {
        ...mapActions("apps", ["getPagedApps"]),
        ...mapActions("main", ["apiLogs", "securityLogs", "attachmentLogs"]),
        clickExport(type) {
            this.resetDialogFields();
            this.getToday();
            switch (type) {
                case "api": this.currentDialog = "api"; break;
                case "security": this.currentDialog = "security"; break;
                case "attachments": this.currentDialog = "attachments"; break;
                default:
            }
            this.showDialog = true;
        },
        resetDialogFields() {
            this.fromDateTime = "";
            this.toDateTime = "";
            this.fromDateTimeErr = false;
            this.toDateTimeErr = false;
            this.selectedApp = null;
        },
        dialogOk() {
            if (!this.fromDateTime && !this.toDateTime) {
                this.fromDateTimeErr = true;
                this.toDateTimeErr = true;
                this.showDialog = true;
            } else if (!this.fromDateTime) {
                this.showDialog = true;
                this.fromDateTimeErr = true;
            } else if (!this.toDateTime) {
                this.showDialog = true;
                this.toDateTimeErr = true;
            } else {
                const payload = {
                    from: date.formatDate(this.fromDateTime, CATALOGS_DATE_LINE_FORMAT),
                    to: date.formatDate(this.toDateTime, CATALOGS_DATE_LINE_FORMAT)
                };
                if (this.currentDialog !== "security") {
                    payload.applicationId = this.selectedApp && this.selectedApp.length ? this.selectedApp[0].value : "";
                }
                switch (this.currentDialog) {
                    case "api": this.exportFileApi(payload); break;
                    case "security": this.exportFileSecurity(payload); break;
                    case "attachments": this.exportFileAttachments(payload); break;
                    default:
                }
                this.showDialog = false;
                this.currentDialog = "";
            }
        },
        exportFileApi(payload) {
            this.apiLogs(payload).then(() => {
                this.exportSuccessfullNotify();
            });
        },
        exportFileSecurity(payload) {
            this.securityLogs(payload).then(() => {
                this.exportSuccessfullNotify();
            });
        },
        exportFileAttachments(payload) {
            this.attachmentLogs(payload).then(() => {
                this.exportSuccessfullNotify();
            });
        },
        exportSuccessfullNotify() {
            this.$toast.showNotify({
                type: "success",
                message: this.$t("admin.logs.notifyMessage")
            });
        },
        getSearchValue(value) {
            this.searchAppValue = value;
        },
        hideApps() {
            this.searchAppValue = "";
        },
        checkFromDateTime() {
            if (this.fromDateTime) {
                this.fromDateTimeErr = false;
            }
        },
        checkToDateTime() {
            if (this.toDateTime) {
                this.toDateTimeErr = false;
            }
        },
        checkFromDateTimeSecurity() {
            if (this.fromDateTimeSecurity) {
                this.fromDateTimeErrSecurity = false;
            }
        },
        checkToDateTimeSecurity() {
            if (this.toDateTimeSecurity) {
                this.toDateTimeErrSecurity = false;
            }
        },
        optionsFromDate(selectableDate) {
            const newDate = date.formatDate(selectableDate, CATALOGS_DATE_LINE_FORMAT);
            const toDate = this.showDialog ? this.toDateTime : this.toDateTimeSecurity;
            const endDate = date.formatDate(toDate, CATALOGS_DATE_LINE_FORMAT);
            const toMinusOneMonth = this.addMonths(endDate, -1);
            const toMinusOneMonthFormatted = date.formatDate(toMinusOneMonth, CATALOGS_DATE_LINE_FORMAT);
            return (newDate <= this.today && !endDate) || (endDate && newDate >= toMinusOneMonthFormatted && newDate <= this.today && newDate <= endDate);
        },
        getToday() {
            const currentDate = new Date();
            this.today = `${currentDate.getFullYear()
            }-${
                this.formatDate(currentDate.getMonth() + 1)
            }-${
                this.formatDate(currentDate.getDate())}`;
            this.today = date.formatDate(this.today, "YYYY-MM-DD");
        },
        formatDate(value) {
            return value < 10 ? `0${value}` : value;
        },
        optionsToDate(selectableDate) {
            const fromDate = this.showDialog ? this.fromDateTime : this.fromDateTimeSecurity;
            const newDate = date.formatDate(selectableDate, CATALOGS_DATE_LINE_FORMAT);
            const startDate = date.formatDate(fromDate, CATALOGS_DATE_LINE_FORMAT);
            const fromPlusOneMonth = this.addMonths(startDate, 1);
            const fromPlusOneMonthFormatted = date.formatDate(fromPlusOneMonth, CATALOGS_DATE_LINE_FORMAT);
            return (newDate <= this.today && !startDate)
            || (startDate && newDate >= startDate && newDate <= fromPlusOneMonthFormatted && newDate <= this.today);
        },
        addMonths(dateParam, months) {
            const newDate = new Date(dateParam);
            newDate.setMonth(newDate.getMonth() + months);
            return newDate;
        },
        searchData(value, loadMore) {
            this.searchAppPayload.search = value || "";
            if (loadMore) {
                this.searchAppPayload.page++;
                this.getApplications(loadMore);
            } else {
                this.searchAppPayload.page = 0;
                this.getApplications();
            }
        },
        getApplications(loadMore) {
            const appsList = [];
            this.getPagedApps(this.searchAppPayload).then((rsp) => {
                if (rsp.data.apps.length) {
                    rsp.data.apps.forEach(item => {
                        appsList.push({
                            label: item.name,
                            value: item.id
                        });
                    });
                    if (loadMore) {
                        this.appsOptions = this.appsOptions.concat(appsList);
                    } else {
                        this.appsOptions = [];
                        this.appsOptions = appsList;
                    }
                } else {
                    this.appsOptions = [{ label: this.$t("applicationPermissions.noResultsFound"), itemDisabled: true }];
                }
            });
        },
        showResults() {
            this.optionsMenu = this.$refs.appsRef.$refs.menuDropdown.$children[0].$children[0].$children[1].$el;
            if (this.optionsMenu && this.optionsMenu.offsetHeight) {
                const checkSearch = this.optionsMenu.offsetHeight < 100;
                if (checkSearch) {
                    this.optionsMenu = this.$refs.appsRef.$refs.menuDropdown.$children[0].$children[0].$children[0].$el;
                }
            }
            this.optionsMenu.addEventListener("scroll", () => {
                if (this.optionsMenu.offsetHeight + this.optionsMenu.scrollTop >= this.optionsMenu.scrollHeight - 1
                    && !this.searchAppValue && this.hasMoreApps) {
                    this.searchData(null, true);
                }
            });
        }
    }
};
